import { render, staticRenderFns } from "./Dokumentation.vue?vue&type=template&id=4bb0a8b6&scoped=true&"
import script from "./Dokumentation.vue?vue&type=script&lang=js&"
export * from "./Dokumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb0a8b6",
  null
  
)

export default component.exports